import React from 'react';
import {
  Button,
  ButtonGroup,
  Heading,
  TextStyle
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { EVENT } from '@nile/components/src/Pages/SystemTrayChatPage/constants';
import { getTranslatedText } from '@nile/components';
import { takeSnapShot } from '../utils/screenshot';

const ScreenshotConfirmation = ({
  closeToastContainer,
  sendMessage,
  customHeaders,
  generateConversationId,
  threadData,
  intl
}) => {
  const getNextId = () => {
    return generateConversationId()
      .then((res) => {
        const nextId = res?.data?.getNextIdentifier || null;
        sessionStorage.setItem('screenshotId', nextId);
        if (nextId) {
          takeSnapShot({
            customHeaders: customHeaders,
            formData: {
              module: 'CONVERSATION_THREAD_ATTACHMENT',
              details: {
                threadId: threadData?.threadId,
                conversationId: nextId
              }
            }
          });
        }
      })
      .catch((err) => null)
      .finally(() => {
        closeToastContainer();
      });
  };
  return (
    <div className="flex fcol g10 p20">
      <div className="flex-center">
        <div className="flex-center">
          <SVGIcon name="WarningOutline" color="#FFC389" size="xl" />
        </div>
        <div className="flex f11 mlr10">
          <Heading element="h2">
            {getTranslatedText(intl, 'common.warning')}
          </Heading>
        </div>
      </div>
      <div className="flex font-black">
        <TextStyle weight="Medium">
          {getTranslatedText(
            intl,
            'msp.chat.technician.screenshot.confirmation.title'
          )}
        </TextStyle>
      </div>
      <div className="flex fcol g10 font-black">
        <div className="flex">
          <TextStyle weight="Medium">
            {getTranslatedText(
              intl,
              'msp.chat.technician.screenshot.confirmation.description'
            )}
          </TextStyle>
        </div>
        <ButtonGroup spacing="loose">
          <Button
            primary
            onClick={() => {
              getNextId();
            }}
          >
            {getTranslatedText(intl, 'role.operation.allow')}
          </Button>
          <Button
            onClick={() => {
              sendMessage({
                type: EVENT.AGENT_EVENT,
                event: EVENT.CONVERSATION_MESSAGE,
                conversation: {
                  data: {
                    type: EVENT.EVENT,
                    action: EVENT.REQ_REJECTED_SCREENSHOT_REQUEST
                  }
                }
              });
              closeToastContainer();
            }}
          >
            {getTranslatedText(intl, 'common.label.deny')}
          </Button>
        </ButtonGroup>
      </div>
    </div>
  );
};
export default ScreenshotConfirmation;
